export default "__VITE_ASSET__yBm8ddSC__"